module.exports = __webpack_public_path__ + "static/media/11-image14.e23b78ab.jpg";